import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import AdminContactService from '../../api/services/AdminContactService';

import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const ContactList = () => {
    const [Error, setError] = useState('');
    const [isLoading, setisloading] = useState(true);
    const [ContactList, setContactList] = useState([]);
    // const [currentPage, setCurrentPage] = useState(1);
    // const recordsPage = 50;
    // const lastIndex = currentPage * recordsPage;
    // const firstIndex = lastIndex - recordsPage;
    // const records = ContactList.slice(firstIndex, lastIndex);
    // const npage = Math.ceil(ContactList.length / recordsPage)
    // const number = [...Array(npage + 1).keys()].slice(1)
    const navigate = useNavigate();
    const contact = useRef();

     const userData = JSON.parse(localStorage.getItem("user"));
    const userRole = userData?.roles?.map((data) => {
        return data?.name;
    }) || [];
    
    
    // function prePage() {
    //     if (currentPage !== 1) {
    //         setCurrentPage(currentPage - 1)
    //     }
    // }
    // function changeCPage(id) {
    //     setCurrentPage(id);
    // }
    // function nextPage() {
    //     if (currentPage !== npage) {
    //         setCurrentPage(currentPage + 1)
    //     }
    // }


    const getContactList = async () => {

        try {

            let responseData = await AdminContactService.index().json()
            setContactList(responseData.data)
            setisloading(false);
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();

                setError(errorJson.message)
            }
        }
    }
    useEffect(() => {
        if (localStorage.getItem('admintoken')) {

            getContactList();

        }
        else {
            navigate('/');
        }

    }, [])
    const handleDelete = async (e) => {

        try {


            let responseData = await AdminContactService.destroy(e).json()
            if (responseData.status === true) {
                swal("Contact Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getContactList();
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }
    }
    const handleCallback = () => {
        getContactList()
    }
    const updatechecktatus = async (e) => {
        e.preventDefault();
        let userid = e.target.id
        try {
            var userData = {
                id: userid
            }
            let responseData = await AdminContactService.updatecheckstatus(userData).json();
            let responseDataContact = await AdminContactService.updateInquiriesstatus(userid).json();

            if (responseData.status === true || responseDataContact.status == true) {

                // swal("Updated!!!").then((updatecheckstatus) => {
                //     if (updatecheckstatus) {
                //         getContactList();
                //         window.location.reload();
                //     }
                // })
                getContactList();

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    }
    return (
        <>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                        <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                            <h4 className="heading mb-0">{userRole.includes("Staff") ? "Kontaktliste":"Contact List"}</h4>
                                            {userRole.includes("Staff") ? "" : (
                                                <div>
                                                <Link to={`/admin/add-contact`}className="btn btn-primary btn-sm ms-1"
                                                    
                                                >+ Add contact</Link> {" "}
                                            </div>
                                            )}
                                        </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr style={{ textAlign: 'center' }}>
                                                    <th >
                                                        <strong>{userRole.includes("Staff") ? "Nr." : "No."}</strong>
                                                    </th>
                                                    <th>
                                                        <strong>{userRole.includes("Staff") ? "Geprüft" : "Checked"}</strong>
                                                    </th>
                                                    <th>
                                                        <strong>{userRole.includes("Staff") ? "Camper-Modell" : "Camper Model"}</strong>
                                                    </th>
                                                    <th>
                                                        <strong>{userRole.includes("Staff") ? "Typ" : "Type"}</strong>
                                                    </th>
                                                    <th>
                                                        <strong>{userRole.includes("Staff") ? "Name" : "Firstname"}</strong>
                                                    </th>
                                                    <th>
                                                        <strong>{userRole.includes("Staff") ? "E-Mail" : "Email"}</strong>
                                                    </th>
                                                    <th>
                                                        <strong>{userRole.includes("Staff") ? "Telefonnummer" : "Phone"}</strong>
                                                    </th>
                                                    <th>
                                                        <strong>{userRole.includes("Staff") ? "Buchungsnummer" : "Booking Number"}</strong>
                                                    </th>
                                                    <th>
                                                        <strong> {userRole.includes("Staff") ? "Anfragegrund" : "Request Reason"}</strong>
                                                    </th>
                                                    <th>
                                                        <strong>{userRole.includes("Staff") ? "Nachricht" : "Message"}</strong>
                                                    </th>
                                                    {userRole.includes("Staff") ? "" : <th><strong>Action</strong></th>}
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    ContactList.map((element, index) => {
                                                        
                                                        return (
                                                            <tr style={{ textAlign: 'center' }}>
                                                                <td>
                                                                    {index + 1}
                                                                </td> 
                                                                <td>{element.is_checked == 0 || element.ischecked == 1 ? <span className="btn btn-danger btn-sm ms-1">{userRole.includes("Staff") ? "Nicht geprüft":"Not Checked"}</span>  : 
                                                                <span className="btn btn-success btn-sm ms-1 " >{userRole.includes("Staff") ? "Überprüft":"Checked"}</span>}
                                                                {userRole.includes("Admin") && ( <Link id={element.id} onClick={updatechecktatus}> Change?</Link>)}
                                                               </td>
                                                                <td>
                                                                    {element.camper_id ? element.camper_id : "_"}

                                                                </td>
                                                                <td>
                                                                    {element.type}

                                                                </td>
                                                                <td>
                                                                    {element.firstName}

                                                                </td>

                                                                <td>{element.email}</td>
                                                                <td>{element.phone}</td>
                                                                <td>{element.bookingNumber}</td>
                                                                <td>{element.reasonRequest}</td>
                                                                <td style={{ whiteSpace: 'pre-line' }}>{element.message}</td>
                                                                {userRole.includes("Staff") ? "" : ( <td>
                                                                    <div className="d-flex">

                                                                        <Link
                                                                            onClick={() =>
                                                                                swal({
                                                                                    title: "Are you sure?",
                                                                                    text: "Once deleted, you will not be able to recover this data!",
                                                                                    icon: "warning",
                                                                                    buttons: true,
                                                                                    dangerMode: true,
                                                                                }).then((willDelete) => {
                                                                                    if (willDelete) {
                                                                                        (handleDelete(element.id));
                                                                                    }
                                                                                })
                                                                            }

                                                                            className="btn btn-danger shadow btn-xs sharp"
                                                                        >
                                                                            <i className="fa fa-trash"></i>
                                                                        </Link>
                                                                    </div>
                                                                </td>)}
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>

                                        </table>
                                        {/* <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {ContactList.length < lastIndex ? ContactList.length : lastIndex}
                                                {" "}of {ContactList.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}


        </>
    );
};

export default ContactList;
